import { Collection } from '@/state/Collection';
import { _ACTIVITIES } from "@/state";

import { ActivitiesRoutes } from '@/repository/resources';

const { GetAllActivities, CreateActivity, DeleteActivity, SearchAllActivities, GetActivityHubspotLink, GetAllHubspotActivities, GetActivityHubspotLinkWithEngagement } = ActivitiesRoutes;

// Export this module
export default {
	namespaced: true,
	state: {
		all: Collection.stateDefaults(),
		_all: new Collection({ statePath: 'activities.all' })
	},
	actions: {

		async index({ commit }, args) {
			try {
				let { page, per_page } = Object.assign({}, args)
				let res = await GetAllActivities({ page, per_page });
				commit('SET_ACTIVITIES_LIST', res.data);
			}
			catch (error) {
				console.error('Activities could not be indexed.', error);
				throw error;
			}
		},

		async indexNextPage({ commit }) {
			try {
				if (_ACTIVITIES().pagination.isLastPage()) {
					return;
				}

				let res = await GetAllActivities({ page: _ACTIVITIES().pagination.nextPage() })
				commit('APPEND_MULTIPLE_ACTIVITIES_TO_LIST', res.data);
			}
			catch (error) {
				console.error('Next page of activities could not be indexed.', error);
				throw error;
			}
		},

		async search({ commit }, args) {
			try {
				let { page, per_page, searchTerm } = Object.assign({}, args)
				let res = await SearchAllActivities({ page, per_page, searchTerm });
				commit('SET_ACTIVITIES_LIST', res.data);
			}
			catch (error) {
				console.error('Activities from search could not be indexed.', error);
				throw error;
			}
		},

		async searchNextPage({ commit }, args) {
			try {
				if (_ACTIVITIES().pagination.isLastPage()) {
					return;
				}

				let { per_page, searchTerm } = Object.assign({}, args)
				let page = _ACTIVITIES().pagination.nextPage();
				let res = await SearchAllActivities({ page, per_page, searchTerm });
				commit('APPEND_MULTIPLE_ACTIVITIES_TO_LIST', res.data);
			}
			catch (error) {
				console.error('Next page of activities from search could not be indexed.', error);
				throw error;
			}
		},

		async create({ commit }, { activity }) {
			try {
				let res = await CreateActivity({ activity });
				commit('PREPEND_SINGLE_ACTIVITY_TO_LIST', res.data);
				return res
			}
			catch (error) {
				console.error('Activity could not be created.', error);
				throw error;
			}
		},

		async delete({ commit }, { activity }) {
			try {
				let res = await DeleteActivity({ activity });
				if (res.status !== 204) {
					throw 'Problem occurred when deleting activity.';
				}
				commit('DELETE_ACTIVITY', activity)
				return true;
			}
			catch (error) {
				console.error('Activity could not be deleted.', error);
				throw error;
			}
		},

		async getHubspotLink({ commit }, { activity }) {
			try {
				return await GetActivityHubspotLink({ activity });
			} catch (error) {
				console.error('Activity could not find Hubspot Link.', error);
				throw error;
			}
		},

		async getHubspotLinkWithEngagement({ commit }, { engagement_id, type }) {
			try {
				return await GetActivityHubspotLinkWithEngagement({ engagement_id, type });
			} catch (error) {
				console.error('Activity could not find Hubspot Link.', error);
				throw error;
			}
		},

		async getHubspotActivities({ commit }, { sprint, type, page, filteredUserIds, filteredActionIds, filteredTypes, start, end }) {
			try {
				return await GetAllHubspotActivities({ sprint, type, page, filteredUserIds, filteredActionIds, filteredTypes, start, end });
			} catch (error) {
				console.error('Activities could not be indexed.', error);
				throw error;
			}
		}

	},
	mutations: {
		SET_ACTIVITIES_LIST(state, data) {
			state._all.items.set(data).commitToState()
		},
		APPEND_MULTIPLE_ACTIVITIES_TO_LIST(state, objs) {
			state._all.items.appends(objs).commitToState();
		},
		PREPEND_SINGLE_ACTIVITY_TO_LIST(state, obj) {
			state._all.items.prepend(obj).commitToState();
		},
		UPDATE_ACTIVITY(state, obj) {
			state._all.items.updateItem(obj, 'id').commitToState();
		},
		DELETE_ACTIVITY(state, obj) {
			state._all.items.deleteItem(obj).commitToState();
		},

	}
}
